module.exports = __webpack_public_path__ + "static/media/f-secure.4e8e196a.webp";